import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  errorType: '404' | 'bad-gateway';

  info = {
    '404': {
      image: '404.png',
      title: 'Oops. The page you were looking for doesn’t exist.',
      subtitle: 'You may have mistyped the address or the page may have moved.'
    },
    'bad-gateway': {
      image: '500.png',
      title: 'Oops. Our servers are temporarily unavailable',
      subtitle: 'Please wait a minute until we fix it'
    }
  };



  constructor(
    private activatedRoute: ActivatedRoute
  ) { }



  ngOnInit() {
    this.getErrorType();
  }



  private getErrorType(): void {
    this.errorType = this.activatedRoute.snapshot.params['error'];
  }

}
